var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{class:{ admin: _vm.userType === 'admin' },attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.filePath,"type":"audio/mpeg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }